import { getTvObject, tv } from '@costar-ui/cosmos';

var starRatingTvObject = getTvObject({
  slots: {
    container: 'flex flex-row text-action-selected',
    star: 'shrink-0'
  },
  variants: {
    size: {
      sm: {
        star: 'size-[.875rem]'
      },
      std: {
        star: 'size-[1rem]',
        container: 'gap-px'
      },
      md: {
        star: 'size-[1.25rem]',
        container: 'gap-[.1875rem]'
      },
      lg: {
        star: 'size-[1.5rem]',
        container: 'gap-1'
      }
    }
  }
});
var starRatingStyles = tv(starRatingTvObject);

export { starRatingStyles, starRatingTvObject };
//# sourceMappingURL=star-rating-styles.esm.js.map
